import { render, staticRenderFns } from "./Down.vue?vue&type=template&id=633034e7&scoped=true&"
import script from "./Down.vue?vue&type=script&lang=js&"
export * from "./Down.vue?vue&type=script&lang=js&"
import style0 from "./Down.vue?vue&type=style&index=0&id=633034e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633034e7",
  null
  
)

export default component.exports